import { RouteRecordRaw } from "vue-router";

const platformRoutes: RouteRecordRaw[] = [
  {
    path: "/platformIntro",
    name: "platformIntro",
    meta: {
      label: "api介绍页",
      auth: false,
      layout: "simple"
    },
    component: () => import("@/views/platformCenter/platformIntro/index.vue")
  },
  {
    path: "/platformCenter",
    name: "platformCenter",
    component: () => import("@/views/platformCenter/PlatformLayout.vue"),
    redirect: "/platformCenter/space",
    meta: {
      auth: true,
      title: "API控制台平台",
      label: "API控制台平台",
      layout: "simple",
      layoutHidden: true
    },
    children: [
      {
        path: "space",
        name: "platformCenterSpace",
        component: () => import("@/views/platformCenter/space/index.vue"),
        meta: {
          auth: true,
          title: "API密钥",
          label: "API密钥",
          layoutHidden: true,
          layout: "simple"
        }
      },
      {
        path: "resource",
        name: "platformCenterResource",
        component: () => import("@/views/platformCenter/resource/index.vue"),
        meta: {
          auth: true,
          title: "资源包管理",
          label: "资源包管理",
          layoutHidden: true,
          layout: "simple"
        }
      },
      {
        path: "usage",
        name: "platformCenterUsage",
        component: () => import("@/views/platformCenter/usage/index.vue"),
        meta: {
          notUseSider: true,
          auth: true,
          title: "用量查询",
          label: "用量查询",
          layoutHidden: true,
          layout: "simple"
        }
      }
    ]
  }
];

export default platformRoutes;
